import React from 'react';
import PropTypes from 'prop-types';
import { setLinkCetDataVars } from '~/server/utils/cetTrackingHelper';

class MemberStatus extends React.PureComponent {
  render() {
    const {
      profileUrl,
      supportHuffpostUrl,
      hideSupportUsButton,
    } = this.props;

    const supportHuffpostCetData = setLinkCetDataVars('nav_bar', supportHuffpostUrl, 'Support Us', 'text', 'site_header');

    const supportHuffpostButton = !hideSupportUsButton && supportHuffpostUrl && (
      <a
        className="nav__right__support-button support-button"
        href={supportHuffpostUrl}
        {...supportHuffpostCetData}
      >
        <span className="small-devices">Support Us</span>
      </a>
    );

    const loggedInTemplate = `
      <template amp-access-template type="amp-mustache">
        <a aria-label="Profile" href="${profileUrl}">
          <amp-img layout="fixed" width="30px" height="30px" class="nav__right__profile__image" src={{profile.profileImages.32x32}}></amp-img>
        </a>
      </template>
    `;

    /* eslint-disable jsx-a11y/interactive-supports-focus */
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    return (
      <div className="nav__right__profile__container">
        <div className="nav__right__profile">
          { supportHuffpostButton }
          <section
            amp-access="profile.name.given"
            amp-access-hide="NOT profile.name.given"
            dangerouslySetInnerHTML={{ __html: loggedInTemplate }}
          />
          <button
            amp-access="NOT profile.name.given"
            amp-access-hide="profile.name.given"
            aria-label="Log In"
            className="nav__right__sign-in"
            on="tap:amp-access.login-signup"
          >
            Log In
          </button>
        </div>
      </div>
    );
    /* eslint-enable jsx-a11y/interactive-supports-focus */
    /* eslint-enable jsx-a11y/no-static-element-interactions */
    /* eslint-enable jsx-a11y/click-events-have-key-events */
  }
}

MemberStatus.propTypes = {
  type: PropTypes.string,
  signInUrl: PropTypes.string.isRequired,
  profileUrl: PropTypes.string.isRequired,
  subscribeUrl: PropTypes.string.isRequired,
  supportHuffpostUrl: PropTypes.string,
  hideSupportUsButton: PropTypes.bool,
};

MemberStatus.defaultProps = {
  type: null,
  supportHuffpostUrl: null,
  hideSupportUsButton: false,
};

export default MemberStatus;
